import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, focusVisibleStyles, pxToRem, withTransientProps } from '@lbcamden/lib-react';
import { Content, Root, Trigger } from '@radix-ui/react-collapsible';

import { animateCollapsibleContent } from '~/client/style/mixins';

export const SectionSelectorRoot = styled.div`
  width: 100%;
  max-width: ${pxToRem(570)};
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing([2, 0])};
  border-bottom: ${({ theme }) => theme.borderLight};

  ${Button} {
    text-decoration: underline;
  }
`;

export const CollapsibleRoot = styled(Root)`
  width: 100%;
  max-width: ${pxToRem(570)};
  border-top: ${({ theme }) => theme.borderLight};
  border-bottom: ${({ theme }) => theme.borderLight};
`;

export const CollapsibleTrigger = styled(Trigger, withTransientProps)<{ $open?: boolean }>`
  ${focusVisibleStyles('link')}

  all: unset;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ theme }) => theme.spacing([2, 0])};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.create('background-color')};

  ${({ theme, $open }) =>
    $open &&
    css`
      border-bottom: ${theme.borderLight};

      svg {
        transform: rotate(180deg);
      }
    `};

  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundHover};
  }

  svg {
    transition: ${({ theme }) => theme.transitions.create('transform')};
  }
`;

export const CollapsibleContent = styled(Content)`
  ${animateCollapsibleContent}
  width: 100%;

  ${Section}:last-child {
    border-bottom: 0;
  }
`;
